import React, { useState, useEffect, useCallback } from "react";
import { api } from "../../actions/api";
import ViewMemoryModal from "../../Components/ViewMemoryModal";
import ViewAllMemoryModal from "../../Components/ViewAllMemoryModal";
import MultiLineSkeletonLoader from "../SkeletonLoaders/MultiLineSkeletonLoader";

const MemorySection = () => {
  const [summaryModalOpen, setSummaryModalOpen] = useState(false);
  const [fullMemoryModalOpen, setFullMemoryModalOpen] = useState(false);
  const [currentMemoryJournalId, setCurrentMemoryJournalId] = useState(null);
  const [memory, setMemory] = useState(null);
  const [loading, setLoading] = useState(false);

  const getMemory = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api(`/my-memory`);
      setMemory(response.data.data.memory);
      setCurrentMemoryJournalId(response.data.data.memory.user_journal_id);
    } catch (e) {
      console.error("Error fetching memory", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getMemory();
  }, [getMemory]);

  const openSummaryModal = () => setSummaryModalOpen(true);
  const closeSummaryModal = () => setSummaryModalOpen(false);
  const openFullMemoryModal = () => setFullMemoryModalOpen(true);
  const closeFullMemoryModal = () => setFullMemoryModalOpen(false);
  const handleRefresh = () => getMemory();

  return (
    <>
      <div className="col-md-6">
        <div className="memory-section">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="memory-header mb-0">My Memory</h2>
            <button className="memory-button" onClick={openSummaryModal}>
              View All Memories
            </button>
          </div>
          <p className="memory-text mb-0">
            View a random journal memory and take a moment to reflect on your
            thoughts and experiences.
          </p>
          {loading && (
            <div className="mt-3">
              <MultiLineSkeletonLoader
                lines={3}
                widths={["90%", "80%", "70%"]}
              />
            </div>
          )}
        </div>
      </div>

      <ViewMemoryModal
        open={summaryModalOpen}
        onClose={closeSummaryModal}
        memory={memory}
        loading={loading}
        handleRefresh={handleRefresh}
        setCurrentMemoryJournalId={setCurrentMemoryJournalId}
        openFullMemoryModal={() => {
          closeSummaryModal();
          openFullMemoryModal();
        }}
      />
      <ViewAllMemoryModal
        open={fullMemoryModalOpen}
        onClose={closeFullMemoryModal}
        currentMemoryJournalId={currentMemoryJournalId}
        memoryloading={loading}
        handleRefresh={handleRefresh}
        openSummaryModal={() => {
          closeFullMemoryModal();
          openSummaryModal();
        }}
      />
    </>
  );
};

export default MemorySection;
